class LqdHeaderFullscreenProjectHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initToggle();

  }

  getDefaultSettings() {
    return {
      selectors: {
        toggleElement: '[data-ld-toggle]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $toggleElement: this.$element.find(selectors.toggleElement),
    }
  }

  initToggle() {

    this.elements.$toggleElement.liquidToggle();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdHeaderFullscreenProjectHandler, { $element } );
};